import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BlobServiceClient, BlobUploadCommonResponse, AnonymousCredential, BlobHTTPHeaders, StorageSharedKeyCredential} from '@azure/storage-blob';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AzureBlobService {

  constructor(private httpClient: HttpClient) {
    // this.pdfExtract = PdfExtract();
}
async uploadBlob(url: string, blobname:any, blob: any, url2:any) {
    const blobServiceClient = new BlobServiceClient(url, new AnonymousCredential());
    const containerClient = blobServiceClient.getContainerClient('modificationfiles');
    const blockBlobClient = containerClient.getBlockBlobClient(blobname);
    const options = {
        blobHTTPHeaders: {
            blobContentType: blob.type
        }
    };

    this.blobApiCalling(url2, blob, blob.type).subscribe({
        next: (res:any) => {
            console.log(res);
        },
        error: (e:any) => console.error(e)
    });

    // return blockBlobClient.uploadData(blob, options);
}

blobApiCalling(baseUrl:any, data:any, type: string): Observable<any> {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append('Content-Type', 'image/jpeg');
    httpHeaders = httpHeaders.append('x-ms-blob-type', 'BlockBlob');
    return this.httpClient.put(baseUrl, data, { headers: httpHeaders });
}

/* new blob service */

async uploadFile(file: File, sasUrl: string,file_Name:string) {
    const blobServiceClient = new BlobServiceClient(sasUrl);
    const containerClient = blobServiceClient.getContainerClient('');
    const blockBlobClient = containerClient.getBlockBlobClient(file_Name);

    try {
      const uploadBlobResponse = await blockBlobClient.uploadData(file);
      console.log(`Upload block blob ${file_Name} successfully`, uploadBlobResponse.requestId);
      return uploadBlobResponse;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }
}
